import { SHOPIFY_STORE_DOMAIN, SHOPIFY_STOREFRONT_API_TOKEN } from '@portal/config/base';
import { StoreCode } from '@portal/schema/storeCode';
import { mapStoreCodeToCountryCode } from '@portal/state/hooks/useStoreCountryCode';
import { TAGS } from '../constants';
import { getCollection } from '../queries/collectionsByHandleV2';
import { MULTICURRENCY_STORES } from '../storeCode';
import { CollectionProduct } from '../types';
import { reshapeProducts, shopifyFetch } from '../utils';

async function getCollectionProducts({
  domain,
  token,
  handle,
  identifiers = [],
  countryCode
}: {
  handle: string;
  identifiers?: { key: string; namespace: string }[];
  domain: string;
  token: string;
  countryCode?: string;
}): Promise<CollectionProduct[]> {
  const res = await shopifyFetch<any>({
    query: getCollection,
    tags: [TAGS.collections, TAGS.products],
    shopifyDomain: domain,
    accessToken: token,
    variables: { handle, identifiers, countryCode }
  });

  if (res.body.data.collectionByHandle && res.body.data.collectionByHandle.products.nodes.length) {
    return reshapeProducts(
      res.body.data.collectionByHandle.products.nodes
    ) as unknown as CollectionProduct[];
  }

  return [];
}

export const loadShopifyCollectionProducts = async (
  storeCode: StoreCode,
  handle: string,
  identifiers?: { key: string; namespace: string }[]
): Promise<CollectionProduct[]> => {
  const isMultiCurrency = MULTICURRENCY_STORES.includes(storeCode);

  const products = await getCollectionProducts({
    domain: SHOPIFY_STORE_DOMAIN[storeCode],
    token: SHOPIFY_STOREFRONT_API_TOKEN[storeCode],
    handle,
    identifiers,
    ...(isMultiCurrency && {
      countryCode: mapStoreCodeToCountryCode(storeCode)
    })
  });

  return products;
};
